import { render, staticRenderFns } from "./DashKpis.vue?vue&type=template&id=34c2752b&scoped=true"
import script from "./DashKpis.vue?vue&type=script&lang=js"
export * from "./DashKpis.vue?vue&type=script&lang=js"
import style0 from "./DashKpis.vue?vue&type=style&index=0&id=34c2752b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2752b",
  null
  
)

export default component.exports